<template>
    <div>
        <div class="card mb-3">
            <div class="row no-gutters" style="min-height: 56vh; overflow: auto;">
                <div class="col-md-4" style="border-right: 1px solid #e0e0e0">
                    <div class="card-body">
                        <div class="row">
                            <h3 class="col card-title pt-1">My Wavelets</h3>
                        </div>
                        <div class="row">
                            <div class="col p-0 mb-1"><a-input-search placeholder="Search" style="width: 100%" @search="onSearch" /></div> 
                        </div>
                        <div class="row">
                            <div v-if="ownedWavelets.length > 0" class="col p-0">
                                <a-table rowKey="id" :pagination="{pageSize: 7}" size="middle" :showHeader='false' :columns="ownedWaveletColumns" :data-source="ownedWavelets">
                                    <template slot="info" slot-scope="text, record">
                                        <span span>{{record.name | truncate(30, '...')}}</span> <br>
                                        <small>{{record.description | truncate(30, '...')}}</small> <br>
                                        <small>Author: {{record.developer_account_name | truncate(30, '...')}}</small>
                                    </template>
                                    <template slot="action" slot-scope="text, record">
                                        <div class='d-flex justify-content-end align-items-center'>
                                            <button @click="openAccountWebWavelet(record)" class='btn btn-sm btn-primary' type="primary">Open</button>
                                        </div>
                                    </template>
                                </a-table>
                            </div>
                            <div v-else class='col'>
                                <hr class="mt-0 mb-3">
                                <small>No web wavelets found</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-8">
                    <div v-if='currentWavelet' class="card-body">
                        <div class="row">
                            <h3 class="col card-title fix-overflow">{{currentWavelet.name}}</h3>
                            <!-- <div class="col">
                                <button class='float-right mx-1 btn btn-sm btn-danger' type="primary" @click="uninstall">Uninstall</button>
                                <button class='float-right mx-1 btn btn-sm btn-warning' type="primary" @click="showOptionsDrawer">Settings</button>
                                <button v-if='lynexusIntegration != undefined' class='float-right mx-1 btn btn-sm btn-success' type="primary" @click="lynexusConnect">Lynexus Connect</button>
                            </div> -->
                            <div class="col">
                                 
                                <base-dropdown class="nav-link pr-0 float-right" position="right">
                                    <div class="media align-items-center" slot="title">
                                    <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
                                    </div>
                                    <template>
                                    <div class=" dropdown-header noti-title">
                                        <h6 class="text-overflow m-0">ACTIONS</h6>
                                    </div>
                                    <div class="dropdown-item"
                                        @click.prevent="lynexusConnect">
                                        <i class="fa fa-link"></i>
                                        <span>Lynexus Connect</span>
                                    </div>
                                    <div class="dropdown-item"
                                        @click.prevent="showOptionsDrawer">
                                        <i class="fa fa-book"></i>
                                        <span>History</span>
                                    </div>
                                    <div class="dropdown-item"
                                        @click.prevent="uninstall">
                                        <i class="fa fa-trash"></i>
                                        <span>Uninstall</span>
                                    </div>
                                
                                    </template>
                                </base-dropdown>
                                <button class=" mt-1 btn btn-sm  float-right" 
                                        :class="isAddPosWaveletTerminalFormVisible ? 'btn-danger' : 'btn-success'" 
                                        @click="setPosWaveletTerminalForm">
                                        {{ isAddPosWaveletTerminalFormVisible ? 'Close' : 'Add Terminal' }}
                                </button>
                            </div>
                        </div>    
                        <!-- <div class="row">
                            <div class="col">
                                <button class="float-right mx-1 btn btn-sm" 
                                        :class="isAddPosWaveletTerminalFormVisible ? 'btn-danger' : 'btn-success'" 
                                        @click="setPosWaveletTerminalForm">
                                        {{ isAddPosWaveletTerminalFormVisible ? 'Close' : 'Add Terminal' }}
                                </button>
                            </div>
                        </div>  -->
                        <div v-if="currentWavelet.web_wavelet != null" class="row">
                            <div class="col">
                                <a-tabs :default-active-key="tabDefaultActiveKey">
                                    <a-tab-pane :key="1" v-if='hasAuthentication==true'>
                                        <span slot="tab">
                                        <a-icon :type="lockIcon" />
                                            Authentication
                                            <a-icon v-if='authenticationToken==null' class='ml-2' type="close-circle" theme="twoTone" two-tone-color="#ff0000" />
                                            <a-icon v-else class='ml-2' type="check-circle" theme="twoTone" two-tone-color="#52c41a" />
                                        </span>
                                        <div class="col-12 mt-2 mx-0 my-0">
                                            <h6 class="heading-small text-muted">Username</h6>
                                            <a-input v-model='authentication_username' placeholder="Username"/>
                                        </div>
                                        <div class="col-12 mt-2">
                                            <h6 class="heading-small text-muted">Password</h6>
                                            <a-input-password v-model='authentication_password' placeholder="Password"/>
                                        </div>
                                        <div class="col-12 mt-3">
                                            <button @click="authenticate(authentication_username, authentication_password)" class='btn btn-sm btn-success' type="primary">Authenticate</button>                                            </div>

                                    </a-tab-pane>
                                    <a-tab-pane :key="2" v-if='hasAdditionalConfiguration==true'>
                                        <span slot="tab">
                                            <a-icon type="setting" />
                                            Additional Configuration
                                        </span>
                                        <dynamic-form :convertedJson="additionalConfiguration" :formSettings="this.dynamicData" :key="refreshKey" @valueUpdated="updateSettings" ref="dynamicForm"></dynamic-form>
                                        <button @click="saveDynamicSetting" class='btn btn-sm btn-success' type="primary">Save</button>  
                                    </a-tab-pane>

                                    <a-tab-pane :key="3" v-if='hasIntegratedLynexus==true'>
                                        <span slot="tab">
                                            <a-icon type="deployment-unit" />
                                            Lynexus Connection
                                        </span>
                                        <h4>{{ lynexusIntegrationJson.message }}</h4>
                                        <a-collapse>
                                            <a-collapse-panel v-for="sched in lynexusIntegrationJson.schedules" :key='sched.id' :header="sched.description">
                                                <a-tag slot="extra"><b>cron schedule:</b> {{ sched.cron_schedule }}</a-tag>
                                                <a-tag slot="extra"><b>cron status:</b> {{ sched.cron_status }}</a-tag>
                                                <div class="table-responsive"> 
                                                    <table class="table table-bordered table-sm">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">Name</th>
                                                                <th scope="col">Description</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="task in sched.tasks" :key='task.id'>
                                                                <td>{{task.name}}</td>
                                                                <td>{{task.description}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>     
                                            </a-collapse-panel>
                                        </a-collapse>
                                    </a-tab-pane>
                                </a-tabs>
                            </div>
                        </div>
                        <!-- <div v-else class="row">
                            <div class="col">
                                <a-empty class='mt-5' :image-style="{height: '50px',}" >
                                    <span slot="description"> No Web Wavelet Configuration </span>
                                </a-empty>
                            </div>
                        </div> -->
                        <div v-else-if="isAddPosWaveletTerminalFormVisible" class="row">
                            <div class="col">
                                <site-terminals-wavelet-form  
                                    v-if="currentAccountPosWavelet"  
                                    :key="componentKey" 
                                    :accountPosWaveletId="this.currentAccountPosWavelet.id" 
                                    :waveletId="this.currentWavelet.id"
                                    :isVisible="isAddPosWaveletTerminalFormVisible"
                                    @refreshPage="refreshPage">
                                </site-terminals-wavelet-form>
                            </div>
                        </div>
                        <div v-else class="row">
                            <div class="col">
                                <wavelets-table
                                    v-if="currentAccountPosWavelet"
                                    :key="componentKey"
                                    :accountPosWaveletId="this.currentAccountPosWavelet.id"
                                    :wavelet_id="this.currentWavelet.id"
                                >
                                </wavelets-table>
                            </div>
                        </div>
                    </div>
                    <div v-else class="card-body">
                        <a-empty class='mt-5' :image-style="{height: '50px',}" >
                            <span slot="description"> Please select a wavelet </span>
                        </a-empty>
                    </div>
                </div>
            </div>
        </div>
        <a-drawer
            v-if='currentWavelet'
            width="850"
            :visible="optionsDrawerVisible"
            @close="onOptionsDrawerClose"
            :key="componentKey"
            >
                <wavelet-purchase-form @closeDrawer="closeDrawer" :key="componentKey" :updateMode='true' :closeDrawer='closeDrawer' :showHistory="showHistory"></wavelet-purchase-form>
        </a-drawer> 
    </div>

</template>


<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import WaveletPurchaseForm from './WaveletPurchaseForm.vue'
    import WaveletsTable from '../Tables/WaveletsTable.vue'
    import axios from "axios";
    import { mapState, mapActions } from 'vuex'
    var component_x;
    import DynamicForm from './../DynamicForm.vue'
    import SiteTerminalsWaveletForm from './SiteTerminalsWaveletForm.vue'

    export default {
        components:{
            DynamicForm, WaveletPurchaseForm, WaveletsTable, SiteTerminalsWaveletForm
        },
        mounted: async function(){  
            component_x = this;
            this.retrieveOwnedWavelets();
        },
        filters: {
            truncate: function (text, length, suffix) {
                if (text.length > length){
                    return text.substring(0, length) + suffix;
                }else {
                    return text
                }
            },
        },
        computed: {
            ...mapState(['endPoint']),
        },
        data() {
          return {
            fetching: false,
            ownedWaveletColumns: [{scopedSlots: { customRender: 'info' }},{scopedSlots: { customRender: 'action' }}],
            ownedWavelets: [],
            currentWavelet: null,
            tabDefaultActiveKey: 1,
            activeTab: "3",
            refreshKey: 0,
            additionalConfiguration: null,
            hasAdditionalConfiguration: false,
            authentication: null,
            hasAuthentication: false,
            authentication_username: null,
            authentication_password: null,
            lockIcon: "unlock",
            authenticationToken: null,
            authenticationRefreshToken: null,
            configuration: null,
            optionsDrawerVisible: false,
            componentKey: 0,
            currentAccountWebWavelet: null,
            currentAccountPosWavelet: null,
            currentAccountAppWavelet: null,
            dynamicData: {},
            lynexusIntegration: {},
            lynexusIntegrationDisabled: true,
            currentWaveletAppKey: null,
            currentWaveletAppSecret: null,
            hasIntegratedLynexus: false,
            lynexusIntegrationJson: null,
            isAddPosWaveletTerminalFormVisible: false,
            showHistory: false,
          }
        },
        methods: {
            ...mapActions(['updateSelectedWavelet']),
            async retrieveOwnedWavelets(){
                var ownedWavelets = []
                ownedWavelets = await HTTPRequest.getRequest(component_x.endPoint + 'wavelets/owned', null)
                this.ownedWavelets = ownedWavelets
            },
            async onSearch(value){
                var ownedWavelets = await HTTPRequest.getRequest(component_x.endPoint + 'wavelets/owned?name='+value, null)
                this.ownedWavelets = ownedWavelets
            },
            refreshPage() {
                this.isAddPosWaveletTerminalFormVisible = false;
                this.$refs.vuetable.refresh();
            },
            setPosWaveletTerminalForm(){
                this.isAddPosWaveletTerminalFormVisible = !this.isAddPosWaveletTerminalFormVisible;
            },
            async openAccountWebWavelet(record){
                this.currentWavelet = record
                this.authentication = null
                this.additionalConfiguration = null
                this.currentAccountWebWavelet = null
                this.currentAccountPosWavelet = null
                
                this.authentication_username = null
                this.authentication_password = null
                this.lockIcon = 'unlock'
                this.authenticationToken = null
                if (this.currentWavelet.web_wavelet != null) {
                    var accountWebWavelet = await HTTPRequest.getRequest(component_x.endPoint + 'account_web_wavelets/?web_wavelet_id='+this.currentWavelet.web_wavelet.id, null)
                    if (accountWebWavelet.data.length > 0) {
                        this.currentWaveletAppKey = accountWebWavelet.data[0].wavelet_app_key
                        this.currentWaveletAppSecret = accountWebWavelet.data[0].wavelet_app_secret
                        this.currentAccountWebWavelet = accountWebWavelet.data[0]
                        this.configuration = accountWebWavelet.data[0].configuration
                        this.lynexusIntegration = this.configuration.lynexus_integration
                        
                        var authentication = accountWebWavelet.data[0].configuration.authentication;
                        var additionalConfiguration = accountWebWavelet.data[0].configuration.additional_configuration;

                        if (accountWebWavelet.data[0].configuration.authentication) {
                            if (accountWebWavelet.data[0].configuration.authentication.success_auth) {
                                this.authentication_username = accountWebWavelet.data[0].configuration.authentication.success_auth.username
                                this.authentication_password = accountWebWavelet.data[0].configuration.authentication.success_auth.password
                                this.lockIcon = 'lock'
                                this.authenticationToken = accountWebWavelet.data[0].configuration.authentication.success_auth.token
                                this.authenticationRefreshToken = accountWebWavelet.data[0].configuration.authentication.success_auth.refresh_token
                                this.lynexusIntegrationDisabled = false
                            }
                        }
                        
                        if (accountWebWavelet.data[0].configuration.dynamic_settings_data) {
                            this.dynamicData = accountWebWavelet.data[0].configuration.dynamic_settings_data
                        }

                        if (authentication != undefined) {
                            this.hasAuthentication = true
                            this.authentication = authentication
                        } else {
                            this.hasAuthentication = false
                        }
                        if (additionalConfiguration != undefined) {
                            this.hasAdditionalConfiguration = true
                            this.additionalConfiguration = additionalConfiguration                    
                        }else {
                            this.hasAdditionalConfiguration = false
                        }

                        if (accountWebWavelet.data[0].configuration.lynexus_response != undefined){
                            this.hasIntegratedLynexus = true
                            this.lynexusIntegrationJson = accountWebWavelet.data[0].configuration.lynexus_response
                        } else {
                            this.hasIntegratedLynexus = false
                            this.lynexusIntegrationJson = null
                        }

                        this.refreshKey++
                        this.tabDefaultActiveKey = (authentication != undefined) ? 1 : 2;
                    }
                }

                if (this.currentWavelet.pos_wavelet != null) {
                    var accountPosWavelet = await HTTPRequest.getRequest(component_x.endPoint + 'account_pos_wavelets/?pos_wavelet_id='+this.currentWavelet.pos_wavelet.id, null)
                    if (accountPosWavelet.data.length > 0) {
                        this.currentAccountPosWavelet = accountPosWavelet.data[0]
                    }             
                }

                if (this.currentWavelet.app_wavelet != null) {
                    var accountAppWavelet = await HTTPRequest.getRequest(component_x.endPoint + 'account_app_wavelets/?app_wavelet_id='+this.currentWavelet.app_wavelet.id, null)
                    if (accountAppWavelet.length > 0) {
                        this.currentAccountAppWavelet = accountAppWavelet[0]
                    }             
                }
            },
            async authenticate(username, password){
                if (this.authentication.auth_url) {
                    var auth_endpoint = this.authentication.auth_url
                    var account_payload = {email: username, password: password, grant_type: 'password', account_name: secureStorage.getItem("accountName")}
                    var authentication = await HTTPRequest.postRequest(auth_endpoint, null, account_payload)
                    if (authentication.token || authentication.refresh_token){
                        this.lockIcon = 'lock'
                        this.authenticationToken = authentication.token || ''
                        this.authenticationRefreshToken = authentication.refresh_token || ''
                        
                        var account_web_wavelet_payload = {"success_auth": {"username": this.authentication_username, "password": this.authentication_password, "token": this.authenticationToken, "refresh_token": this.authenticationRefreshToken}}
                        var post_request = await HTTPRequest.postRequest(this.endPoint + 'account_web_wavelets/'+this.currentAccountWebWavelet.id+'/save_configuration_auth', null, account_web_wavelet_payload)
                        
                        this.lynexusIntegrationDisabled = false
                        this.$notification['success']({
                            message: 'Authentication Success',
                        });
                    } else {
                        var account_web_wavelet_payload = {"success_auth": {"username": this.authentication_username, "password": this.authentication_password}}
                        var post_request = await HTTPRequest.postRequest(this.endPoint + 'account_web_wavelets/'+this.currentAccountWebWavelet.id+'/save_configuration_auth', null, account_web_wavelet_payload)

                        this.lynexusIntegrationDisabled = true
                        this.lockIcon = 'unlock'
                        this.authenticationToken = null
                        this.$notification['error']({
                            message: 'Authentication Error',
                        });
                    }
                }
            },
            async updateSettings(formSettings){
                this.additionalConfigurationData = formSettings
            },
            openRedirectLink(){
                var additionalParams = '&'
                if (this.additionalConfigurationData != null){
                    var objectLength = Object.keys(this.additionalConfigurationData).length
                    var counter = 1
                    for (let [key, value] of Object.entries(this.additionalConfigurationData)) {                        
                        additionalParams += key
                        additionalParams += '='
                        additionalParams += value
                        counter++
                        if (counter <= objectLength){
                            additionalParams += '&'
                        }
                    }          
                }
                window.open(this.configuration.redirect_link+"?token="+this.authenticationToken+additionalParams,this.currentSelectedAccountWebWaveletName);
            },
            async showOptionsDrawer(){
                this.componentKey++
                this.optionsDrawerVisible = true;
                this.updateSelectedWavelet(this.currentWavelet)
                this.showHistory = true;
            },
            closeDrawer(){
                this.onOptionsDrawerClose();
            },
            onOptionsDrawerClose(){
                this.componentKey++
                this.optionsDrawerVisible = false;
            },
            async saveDynamicSetting(){
                var account_web_wavelet_payload = {"dynamic_settings": this.additionalConfigurationData}
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'account_web_wavelets/'+this.currentAccountWebWavelet.id+'/save_dynamic_form_settings', null, account_web_wavelet_payload)
            },
            async uninstall(){
                if (this.currentAccountPosWavelet != undefined){
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'account_pos_wavelets/'+this.currentAccountPosWavelet.id+'/uninstall', null, null)
                    if (post_request.message == 'success'){
                        this.$notification['success']({
                                message: 'POS Wavelet is successfully uninstalled',
                        });
                        this.retrieveOwnedWavelets()
                        this.currentWavelet = null
                    }
                }
                if (this.currentAccountWebWavelet != undefined){
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'account_web_wavelets/'+this.currentAccountWebWavelet.id+'/uninstall', null, null)
                    if (post_request.message == 'success'){
                        this.$notification['success']({
                                message: 'Web Wavelet is successfully uninstalled',
                        });
                        this.retrieveOwnedWavelets()
                        this.currentWavelet = null
                        location.reload();
                    }
                }

                if (this.currentAccountAppWavelet != undefined){
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'account_app_wavelets/'+this.currentAccountAppWavelet.id+'/uninstall', null, null)
                    if (post_request.message == 'success'){
                        this.$notification['success']({
                                message: 'App Wavelet is successfully uninstalled',
                        });
                        this.retrieveOwnedWavelets()
                        this.currentWavelet = null
                        location.reload();
                    }
                }
            },
            async lynexusConnect() {
                var jwt = require('jsonwebtoken');
                var token = jwt.sign({data: "aXJpcHBsZS1seW5leHVzLWJ4aQ=="}, "bHluZXh1cy1ieGk=",{algorithm: 'HS256'}) 
                var payload = {
                    "barter_account": {
                        "account_id": secureStorage.getItem("accountId"),
                        "account_name": secureStorage.getItem("accountName"),
                        "account_company_name": secureStorage.getItem("accountCompanyName"),
                    },
                    "integration":{
                        "authentication": {
                            "mysuki": {
                                "username": this.authentication_username,
                                "password": this.authentication_password
                            },
                            "barter":{
                                "refresh_token": secureStorage.getItem("refreshToken"),
                                "grant_type": "refresh_token"
                            }
                        },
                        "configuration": this.dynamicData
                    }
                }
                var lynexus_response = null;
                var lynexus_status = null;
                await axios({
                    method: 'POST',
                    url: 'http://'+this.lynexusIntegration.endpoint,
                    headers: { Authorization: 'Bearer ' + token, "Access-Control-Allow-Origin": "*" },
                    data: payload,
                })
                .then(function (response) {
                    lynexus_response = response.data
                    lynexus_status = response.status
                })  
                .catch(function (error) {
                })

                if (lynexus_status == 200) {
                    var lynexus_response_payload = {"lynexus_response": lynexus_response}
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'account_web_wavelets/'+this.currentAccountWebWavelet.id+'/save_lynexus_response', null, lynexus_response_payload)
                    this.$notification['success']({
                            message: 'Lynexus Connection Success. Please refresh page to retrieve the latest lynexus connection status.',
                    });
                }else{
                    this.$notification['error']({
                            message: 'Lynexus Connection Failed',
                    });
                }
            },
        }
    }
</script>

<style>

</style>


